module.exports = __webpack_public_path__ + "static/img/10.b05459b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/10.png
// module id = l+4G
// module chunks = 0